import datapoints from '../datapoints';
import createAttachmentFromLocalFileService from '../services/createAttachmentFromLocalFile';
import CreateAttachmentResult from '../types/CreateAttachmentResult';
import { getErrorForAttachmentCreationFailure } from '../utils/getErrorForAttachmentCreationFailure';
import { shallowCopyAndReplaceValueNullWithUndefined } from '../utils/shallowCopyAndReplaceValueNullWithUndefined';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { ClientItemId } from 'owa-client-ids';
import AttachmentInfoResponseMessage from 'owa-service/lib/contract/AttachmentInfoResponseMessage';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import CreateAttachmentResponse from 'owa-service/lib/contract/CreateAttachmentResponse';
import {
    AttachmentFullViewState,
    AttachmentState,
    AttachmentStateType,
    setActionCompletePercent,
} from 'owa-attachment-full-data';

// If you change the order of the arguments then also change the custom data function
// for the datapoint.
export default createLegacyActionWithDatapoint(
    'createAttachmentFromLocalFile',
    datapoints.AttachmentCreationClassicFromLocalFile
)(async function createAttachmentFromLocalFile(
    parentItemId: ClientItemId,
    attachment: AttachmentType,
    cancellationId: string,
    backingObject: Blob,
    attachmentState: AttachmentState
): Promise<CreateAttachmentResult> {
    let onProgressHandler = null;

    if (attachmentState.attachmentType === AttachmentStateType.Attachment) {
        onProgressHandler = function (e: ProgressEvent) {
            const loaded = e.loaded / e.total;
            setActionCompletePercent(<AttachmentFullViewState>attachmentState, loaded);
        };
    }

    // filter out null properties and do not send them back to server
    const attachmentForServiceCall = shallowCopyAndReplaceValueNullWithUndefined(attachment);
    const response: CreateAttachmentResponse = await createAttachmentFromLocalFileService(
        parentItemId,
        attachmentForServiceCall,
        cancellationId,
        backingObject,
        onProgressHandler
    );

    const responseMessage: AttachmentInfoResponseMessage = response.ResponseMessages.Items[0];
    if (
        responseMessage &&
        responseMessage.Attachments.length > 0 &&
        responseMessage.Attachments[0]
    ) {
        const result: CreateAttachmentResult = {
            attachment: responseMessage.Attachments[0],
            sharingInfo: null,
        };
        return result;
    } else {
        throw getErrorForAttachmentCreationFailure(responseMessage);
    }
});
